import React from 'react';
import { NextPage, NextPageContext } from 'next';
import Router from 'next/router';
import { Page } from 'shared-types/Common';
import styled from 'styled-components';

import Markdown from '@common/components/Markdown';
import SectionContainer from '@common/components/SectionContainer';
import { Button } from '@common/components/Button/Button';

import * as entityActions from '@store/entity/actions';
import { NormalizedStore } from '@store/entity/entity.types';
import { entitySelectors } from '@store/entity/selectors';

type PrivacyAndCookieProps = {
  page: Page;
};

type PrivacyAndCookieInitialProps = {
  store: NormalizedStore;
  language: string;
} & NextPageContext;

const ButtonWrapper = styled.div`
  margin: 20px 0;
`;

const PrivacyAndCookie: NextPage<PrivacyAndCookieProps> = ({ page }) => {
  const handleEditCookiePreferences = () => {
    if (typeof window !== 'undefined' && (window as any).CookieScript) {
      (window as any).CookieScript.instance.show();
    }
  };

  if (!page) {
    return null;
  }

  return (
    <SectionContainer>
      <h2>{page.title}</h2>
      <ButtonWrapper>
        <Button isPrimary onClick={handleEditCookiePreferences}>
          Edit Cookie Preferences
        </Button>
      </ButtonWrapper>
      <Markdown text={page.content} />
    </SectionContainer>
  );
};

PrivacyAndCookie.getInitialProps = async ({
  store,
  property,
  language,
  res,
}: PrivacyAndCookieInitialProps): Promise<PrivacyAndCookieProps> => {
  await entityActions.fetchPrivacyAndCookiesPage(property.id, language)(store.dispatch);

  const page = entitySelectors.getPage(store.getState(), 'privacy-and-cookies');

  if (!page) {
    if (res) {
      res.writeHead(302, {
        Location: '/',
      });
      res.end();
    } else {
      Router.push('/');
    }
  }

  return {
    page,
  };
};

export default PrivacyAndCookie;
